import {
  getTaskListQuery,
  listAllChecklistsQuery,
} from '@akin-home/checklists/frontend';
import {
  createChecklistChatItem,
  createOutputTextItem,
} from '../../ChatItem/functions';
import { AddChatItemFunction } from '../../types';
import { ShowChecklistCommand } from '../types';

const showListCommand = async (
  /** Command data */
  commmand: ShowChecklistCommand,
  /** Response */
  addItem: AddChatItemFunction
) => {
  const result = ShowChecklistCommand.safeParse(commmand);

  if (!result.success) {
    return;
  }

  const {
    data: { id, not_found_message, title },
  } = result.data;

  if (id) {
    const checklist = (await getTaskListQuery({ id })).data.getTaskList;

    if (checklist) {
      addItem(createChecklistChatItem(id));
      return;
    }
  } else if (title) {
    const items = await listAllChecklistsQuery({
      query: { title },
    });

    if (items.length > 0) {
      addItem(createChecklistChatItem(items[0].id));
      return;
    }
  }

  if (not_found_message) {
    addItem(createOutputTextItem(not_found_message));
  }
};

export default showListCommand;
